<template>
  
  <div class="recruitment-request">
    <!-- <my-breadcrumb :data="breadcrumbs"></my-breadcrumb> -->
      <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" :icon="icon" @createForm="dialog.state=true" ></myBreadCrumb> -->
      

      <!-- <create-dialog-health-insurance ref="createHealthInsurance" @needFetch="fetchData"></create-dialog-health-insurance> -->
      <v-card class="rounded-xl" flat>
          <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
              Thông tin về gia đình
              <v-spacer></v-spacer>
              
              <div class="d-flex align-center wrapper mx-1 my-1">
                  <v-btn @click="gets" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                  <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
              </div>
              
              <v-divider vertical class="mx-4"></v-divider>

              <v-btn dark color="teal darken-4" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6" @click="createDialog = true">
                  <v-icon left>mdi-plus</v-icon> TẠO MỚI
              </v-btn>
          </v-card-title>
          
          <v-sheet class="grey lighten-4 py-6">
              <div class="d-flex flex-wrap mx-n2 px-4">
                  <v-text-field v-model="search" hide-details label="Nhập thông tin tìm kiếm (Tên, CCCD, SĐT...)" persistent-placeholder outlined dense class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="background-color: white;"></v-text-field>
              </div>
          </v-sheet>
          
          <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
              <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
              <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                  <v-icon left small>mdi-account-group-outline</v-icon>
                  Tổng thành viên: <b class="ml-1">{{ totalCount }}</b>
              </v-chip>
              <v-chip color="green lighten-4" text-color="green darken-4" class="font-weight-medium" small>
                  <v-icon left small>mdi-account-check-outline</v-icon>
                  Người phụ thuộc: <b class="ml-1">{{ dependantCount }}</b>
              </v-chip>
          </v-sheet>

          <v-data-table height="600px"
          :headers="headers"
          :page="page"
          :items="data"
          :search="search"
          :loading="isLoading"
          group-by="employeeCode"
          >
              <template v-slot:group.header="{ group, items, isOpen, toggle }">
                  <td colspan="100%" class="grey lighten-4">
                      <v-btn icon small @click="toggle" class="mr-2">
                          <v-icon>{{ isOpen ? 'mdi-minus-box-outline' : 'mdi-plus-box-outline' }}</v-icon>
                      </v-btn>
                      <span class="font-weight-bold subtitle-1 mr-2">{{ items[0].employeeName }}</span>
                      <span class="grey--text subtitle-2 mr-3">{{ group }}</span>
                      <v-chip small color="teal lighten-5" text-color="teal darken-4" class="font-weight-medium">
                          <v-icon left small>mdi-account-multiple</v-icon>
                          {{ items.length }} người thân
                      </v-chip>
                  </td>
              </template>

              <template v-slot:[`item.employeeInfo`]="{item}">
                  <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{item.employeeName}}</div>
                  <div class="caption grey--text">{{item.employeeCode}}</div>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                  <v-btn x-small depressed rounded class="mx-1 my-1 blue--text text--darken-3 font-weight-bold" color="blue lighten-4" @click="editItem(item)">
                      <v-icon left small>mdi-pencil</v-icon> Chi tiết
                  </v-btn>
                  <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold" color="grey lighten-4" @click="dialogDelete=true, targetItem = item">
                      <v-icon left small>mdi-delete</v-icon> Xóa
                  </v-btn>
              </template>
              <template v-slot:[`item.relationType`]="{ item }">
                  <v-chip :color="getRelationColor(item.relationType).bg" :text-color="getRelationColor(item.relationType).text" small class="font-weight-medium">
                      <v-icon left small>{{ getRelationColor(item.relationType).icon }}</v-icon>
                      {{relationTypes[item.relationType]}}
                  </v-chip>
              </template>
              <template v-slot:[`item.phoneNumber`]="{ item }">
                  <span v-if="item.phoneNumber" class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-1">mdi-phone-outline</v-icon>
                    {{item.phoneNumber}}
                  </span>
                  <span v-else class="grey--text caption font-italic">Chưa có</span>
              </template>
              <template v-slot:[`item.memberId`]="{ item }">
                  <span v-if="item.memberId" class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-1">mdi-card-account-details-outline</v-icon>
                    {{item.memberId}}
                  </span>
                  <span v-else class="grey--text caption font-italic">Chưa có</span>
              </template>
              <template v-slot:[`item.isDependant`]="{ item }">
                  <v-chip v-if="item.isDependant == 1" color="green lighten-5" text-color="green darken-4" small class="font-weight-medium">
                    <v-icon left small>mdi-account-check-outline</v-icon> Có
                  </v-chip>
                  <v-chip v-else color="grey lighten-4" text-color="grey darken-2" small class="font-weight-medium">
                    Không
                  </v-chip>
              </template>
              <template v-slot:[`item.doB`]="{ item }">
                  <span v-if="item.doB" class="d-flex align-center">
                    <v-icon small color="pink lighten-2" class="mr-1">mdi-cake-variant-outline</v-icon>
                    {{ formatDate(item.doB) }}
                  </span>
              </template>
          </v-data-table>
          
      </v-card>

      <!-- ************** DELETE CONFIRMATION *************** -->
      <!-- <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
              <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
              <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
              <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
              <v-spacer></v-spacer>
              </v-card-actions>
          </v-card>
      </v-dialog> -->
      <create-dialog v-model="createDialog" :item.sync="targetItem"></create-dialog>
    <confirm-dialog v-model="dialogDelete" :item="targetItem" @confirm="cfmDeleteItem" ></confirm-dialog>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import EmployeeFamilyIndexApi from './api.js'
import MyBreadcrumb from '../../../components/MyBreadcrumb.vue';
import ExportExcel from '@/components/ExportExcel'
import CreateDialog from './Create.vue'
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: { 
    MyBreadcrumb,
    ExportExcel,
    CreateDialog,
    ConfirmDialog
  },
  computed: {
    totalCount() {
      return this.data.length;
    },
    dependantCount() {
      return this.data.filter((item) => item.isDependant == 1).length;
    }
  },
  data() {
    return {
      createDialog: false,
      //DATATABLE
      data: [],
      relationTypes: [],
      page: 0,
      totalItem: 0,
      search:"",
      options: {},
      isLoading: true,
      targetItem: undefined,
      headers: [
        { text: 'Thao tác', value: 'actions', sortable: false, width: "11rem"},
        { text: 'Nhân viên', align: 'start', sortable: false, value: 'employeeInfo' },
        { text: '', align: ' d-none', sortable: false, value: 'employeeCode' },
        { text: '', align: ' d-none', sortable: false, value: 'employeeName' },
        { text: 'Họ tên NPT', align: 'start', value: 'memberName' },
        { text: 'Mối quan hệ', align: 'start', value: 'relationType', },
        { text: 'CCCD', value: 'memberId' },
        { text: 'Số điện thoại', value: 'phoneNumber' },
        { text: 'Ngày sinh NPT', value: 'doB' },
        { text: 'Đối tượng phụ thuộc', value: 'isDependant' },
          // { text: 'Đối tượng phụ thuộc', value: 'dateBack' },
      ],

      dialogDelete: false,
      
      // cfmDeleteItem: null,
      
      breadcrumbs: [
        {
          text: 'Thông tin về gia đình',
          disabled: false,
          to: {name: 'EmployeeFamily'}
        },
      ]
    }
  },
  methods: {
    
    getRelationColor(type) {
      if (type === undefined && type !== 0) return { bg: 'grey lighten-5', text: 'grey darken-3', icon: 'mdi-account-outline' };
      const colors = [
        { bg: 'teal lighten-5', text: 'teal darken-4', icon: 'mdi-account-heart-outline' },
        { bg: 'indigo lighten-5', text: 'indigo darken-4', icon: 'mdi-account-child-outline' },
        { bg: 'blue-grey lighten-5', text: 'blue-grey darken-4', icon: 'mdi-home-heart' },
        { bg: 'deep-purple lighten-5', text: 'deep-purple darken-4', icon: 'mdi-account-multiple-outline' },
        { bg: 'cyan lighten-5', text: 'cyan darken-4', icon: 'mdi-human-male-female' },
        { bg: 'brown lighten-5', text: 'brown darken-4', icon: 'mdi-human-child' },
        { bg: 'amber lighten-5', text: 'amber darken-4', icon: 'mdi-account-star-outline' },
        { bg: 'orange lighten-5', text: 'orange darken-4', icon: 'mdi-account-group-outline' },
      ];
      let hash = 0;
      let strType = String(type);
      for (let i = 0; i < strType.length; i++) {
        hash = strType.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    },

    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    
    editItem (item) {
      this.targetItem = item
      this.createDialog  =true
    },

    //fetching
    gets() {
      this.isLoading = true
      return EmployeeFamilyIndexApi.gets().then(d => {
        this.data = d
      }).finally(()=> {
        this.isLoading = false
      })
    },
    
    deleteItem (item) {
          this.dialogDelete = true;
          this.targetItem = item;
      },
    cfmDeleteItem() {
      console.log(this.targetItem)
      return EmployeeFamilyIndexApi.deleteItem(this.targetItem.id).then(() => {
        this.targetItem = null
        this.dialogDelete = false
      }).finally(() => {
        return this.gets()
      })
    },
  },

  created() {
    this.gets()
    
    EmployeeFamilyIndexApi.getRelationType().then(r => {
      this.relationTypes = r.dict
    })
  }
}
</script>